import '../../styles/EduComponents/HeroSection1.css';
import dashboardImage from '../../assets/Images/hero2.webp';
import { Helmet } from 'react-helmet-async';

const HeroSection1 = () => {
  const handleClick = () => {
  const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

  try {
    window.location.href = tidycalUrl;  // FULL PAGE NAVIGATION
  } catch (error) {
    console.error('Error opening TidyCal booking page:', error);
    alert('Unable to open booking page. Please try again.');
  }
};

  return (
    <section className="hero-container1">

<Helmet>
<link
    rel="preload"
    as="image"
    href={dashboardImage}
    type="image/webp"
  />
</Helmet>

      <div className="hero-text1">
        <h1>
          Built by Educators, For <span className="highlight">Educators</span> 
        </h1>
        <p>
            Strawket is a Learning Management Tool that makes it easy to run an academy
         
        </p>
        <div className="hero-buttons1">
          <button onClick={handleClick} className="demo-btn1" aria-label="Book a demo through TidyCal">
     Book a Demo
    </button>
    <a
  href="https://youtu.be/bBvT6X7ZQFo"
  className="action-btn1"
  aria-label="See it in Action"
  target="_blank"
  rel="noopener noreferrer"
>
  See it in Action
</a>

        </div>
      </div>

      {/* <div className="hero-images1">
        <img src={dashboardImage} 
        alt="Strawket Dashboard Preview"
         width="800"
  height="819" // or actual dimensions
  loading="lazy" />
      </div> */}

      <div className="hero-images1">
  <div className="hero-video-wrapper edge-animate">
     {/* SVG BORDER */}
    <svg className="edge-border" viewBox="0 0 100 100" preserveAspectRatio="none">
  <rect
    x="-0.75"
    y="-0.75"
    width="101.5"
    height="101.5"
    rx="4"
    ry="4"
    pathLength="1"
  />
</svg>

    <iframe
      src="https://www.youtube.com/embed/bBvT6X7ZQFo"
      title="Strawket Product Demo"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      loading="lazy"
    />
  </div>
</div>

    </section>
  );
};

export default HeroSection1;
